import { render, staticRenderFns } from "./UserMng.vue?vue&type=template&id=17cf892f&"
import script from "./UserMng.vue?vue&type=script&lang=js&"
export * from "./UserMng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports